
import Uvp1 from '@/svgs/uvp/UVPicon-1.svg'
import Uvp2 from '@/svgs/uvp/UVPicon-2.svg'
import Uvp3 from '@/svgs/uvp/UVPicon-3.svg'
import Uvp4 from '@/svgs/uvp/UVPicon-4.svg'
import Uvp5 from '@/svgs/uvp/UVPicon-5.svg'
import { Modal } from 'antd'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import Image from "next/image"
import styles from "@/styles/uvp.module.scss"

interface Props {
  type?: string
  wideScreen?: boolean
}

export default function UvpBanner({ type, wideScreen }: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null); // 存储 Modal 的内容
  const [uvpList, setUvpList] = useState<any>([])

  useEffect(() => {
    let list = [{
      id: 1,
      title: (
        <>
          <p>30 DAY</p>
          <p>MONEY BACK</p>
        </>
      ),
      imageUrl: <Uvp1 style={{ width: 42 }} />,
      ModalComponent: <ThirtyMoneyBack />
      ,
    }, {
      id: 2,
      title: (
        <>
          <p>REWARD</p>
          <p>PROGRAM</p>
        </>
      ),
      imageUrl: <Uvp2 style={{ width: 46 }} />,
      url: "/article/faq"
    }, {
      id: 3,
      title: (
        <>
          <p>MON-FRI 11AM-6PM NZST</p>
          <p>Call us on 0 9883 0513</p>
        </>
      ),
      imageUrl: <Uvp3 style={{ width: 40 }} />,
      url: "/contact-us"
    }, {
      id: 4,
      title: (
        <>
          <p>NEXT WORKING DAY</p>
          <p>DISPATCH</p>
        </>
      ),
      imageUrl: <Uvp4 style={{ width: 52 }} />,
      url: "/article/faq"
    }, {
      id: 5,
      title: (
        <>
          <p>DIRECT</p>
          <p>IMPORT</p>
        </>
      ),
      imageUrl: <Uvp5 style={{ width: 42 }} />,
      url: "/article/faq"
    }]
    if (type === "viewcart") {
      list = list.filter(item => item.id !== 3)
    }
    setUvpList(list)
  }, [type])

  const dumpUrl = (url: string) => {
    window.location.href = url;
  }


  return (
    <div className={styles['uvp-banner']} style={{ maxWidth: wideScreen ? 1444 : 1200 }}>
      <div className={styles['uvp-main']} id="uvp-banner" style={{ justifyContent: type === "viewcart" ? "space-around" : "" }}>
        {uvpList.map((item: any, index: number) => {
          return (
            <Link key={index} href={item.url || "#"} legacyBehavior>
              <a
                rel="noopener noreferrer"
                className={styles['uvp-item']}
                onClick={(e) => {
                  if (item.ModalComponent) {
                    e.preventDefault(); // 阻止跳转
                    setModalContent(item.ModalComponent); // 设置 Modal 内容
                    setIsModalOpen(true); // 打开 Modal
                  } else {
                    // 改为浏览器默认行为
                    e.preventDefault(); // 阻止跳转
                    dumpUrl(item.url);
                  }
                }}
              >
                {item.imageUrl}
                <h1
                  className={styles['uvp-title']}
                >
                  {item.title}
                </h1>
              </a>
            </Link>
          );
        })}

        {
          isModalOpen &&
          <Modal
            title=""
            width={850}
            centered
            footer={null}
            open={isModalOpen}
            onCancel={() => setIsModalOpen(false)}
          >
            {modalContent}
          </Modal>
        }
      </div>
    </div>
  )
}

const ThirtyMoneyBack = () => (
  <div>
    <div style={{ textAlign: 'center' }}>
      <Image src={`https://img.bestdeals.co.nz/images/money-back-banner.gif`} width={625} height={108} layout="intrinsic" alt='30 DAY MONEY BACK' />
    </div>
    <h1 style={{ fontWeight: 'bold' }}>{`The BestDeals 30 Day Change-of-Mind Policy`}</h1>
    <p>{`Online shopping sometimes means you don't get exactly what you had in mind. You are welcome to return the item as long as you meet the following terms and conditions as listed below:`}</p>
    <h1 style={{ fontWeight: 'bold' }}>{`Terms & Conditions`}</h1>
    <ul style={{ listStyle: "disc", paddingLeft: '20px' }}>
      <li>{`Notification is required within 30 days of purchase date.`}</li>
      <li>{`Item to be returned must be in their original re-saleable condition with all tags and packaging (ready to be put back on the shelf).`}</li>
      <li>{`The item/s are NOT opened, used, worn or damaged.`}</li>
      <li>{`That you DO NOT stick or write anything on the item itself or its packaging. Please only write or place postage stickers on the outer postage packaging.`}</li>
      <li>{`Some items are not eligible for refund due to hygienic reasons`}</li>
      <li>{`The refund amount will not include delivery costs. If the item was delivered for free, delivery cost will be deducted.`}</li>
      <li>{`Handling fees will apply at 20% of the purchase price.`}</li>
      <li>{`The return of the item is the responsibility of the buyer.`}</li>
      <li>{`If the item has sustained damage in transit or does not return as noted above, a revised refund amount may be required<br />
        If you would like to take this offer, please send us an email at `}
        <Link href={'mailto:info@bestdeals.co.nz'} legacyBehavior>
          <a rel="noopener noreferrer">info@bestdeals.co.nz</a>
        </Link>{` and indicate the Order ID the item/s you wish to return and the reason for the return. Our Customer Service team will reply to your email and, if applicable, issue you a Return Authorization (RA) number. All other relevant information will be given to you at this time. BestDeals will not accept any return of any item/s without an RA from our Customer Service Representative.
        For full details on our return policy, visit our `}
        <Link href={'/article/faq'} legacyBehavior>
          <a rel="noopener noreferrer">Warranty &amp; Returns FAQ</a>
        </Link>
      </li>
    </ul>
  </div>
)